(function ($, Drupal, once) {
  // eslint-disable-next-line no-param-reassign
  function closeModal(context, target) {
    target.fadeOut(500).remove();
  }

  Drupal.behaviors.modalWindow = {
    attach: function (context) {
      const contentBody = $('body', context);

      var simulateClick = function (elem) {
        // Create our event (with options)
        var evt = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        // If cancelled, don't dispatch our event
        var canceled = !elem.dispatchEvent(evt);
      };

      // open modal window
      once('modalWindowOpen', '.m-modal-window--trigger', context).forEach(function (item) {
        $(item).on('click', function (e) {
          let modalTarget = $(item).data('modal-scope');
          let modalContent = $('#' + modalTarget).html();

          // generate modal and append to body
          let generatedModal = $('<div/>')
            .addClass('m-modal-window--generated')
            .html(modalContent);

          contentBody.append(generatedModal);
          generatedModal.addClass('open');
          // Set autoplay attribute on modal open.
          generatedModal.find('video').each(function () {
            this.setAttribute('autoplay', '');
          });

          generatedModal.find('iframe').each(function () {
            let src = this.getAttribute('src');
            this.setAttribute('src', src + '?autoplay=1');
            this.setAttribute('autoplay', '1');
          });

          // add close listeners
          let closeTrigger = generatedModal.find('.m-modal-window--close');

          closeTrigger.each(function (trigger) {
            $(this).on('click', function (e) {
              closeModal(context, generatedModal);
            });
          });

          // add escape key press listerner
          $(document).on('keyup', function (e) {
            if (e.key === 'Escape') {
              closeModal(context, generatedModal);
            }
          });
        });
      });
    },
  }
  ;
  // eslint-disable-next-line no-undef

})(jQuery, Drupal, once);
